import React from 'react'
import { Box, styled, ThemeProvider, Toolbar, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { RoboIcon } from '@rsmus/myrsm-icons'
import { Styles } from '../../types'
import NewRsmLogo from '../media/NewRsmLogo'
import tokens from '../../styles/tokens.json'
import Footer from '../layouts/Footer'
import { normalTheme } from '../../styles/materialTheme'

const styles: Styles = {
  toolbar: () => ({
    display: 'flex',
    height: '5.4375rem',
    alignContent: 'center',
    alignItems: 'center',
  }),
  toolbarRedesign: (theme) => ({
    display: 'flex',
    height: '5.4375rem',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
    [theme.breakpoints.down('tablet')]: {
      justifyContent: 'flex-end',
    },
    [theme.breakpoints.down('desktop')]: {
      justifyContent: 'flex-end',
    },
  }),
  homeIcon: (theme) => ({
    position: 'absolute',
    left: 0,
    paddingBottom: '0.5rem',

    [theme.breakpoints.only('mobile')]: {
      paddingLeft: '0.5rem',
    },

    [theme.breakpoints.down('tablet')]: {
      '& svg': {
        width: '5rem',
      },
    },
    [theme.breakpoints.up('tablet')]: {
      top: '1.5rem',
    },
  }),
  toolbarContainer: (theme) => ({
    height: 'fit-content',
    backgroundColor: tokens.colors.black,
    backgroundImage: `url(${process.env.PUBLIC_URL}/myRSMHeaderBackground.svg)`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    [theme.breakpoints.only('tablet')]: {
      paddingLeft: '2rem',
      paddingRight: '2rem',
    },
    [theme.breakpoints.up('desktop')]: {
      paddingLeft: '6.5rem',
      paddingRight: '6.5rem',
    },
  }),
  contentContainer: {
    backgroundColor: tokens.colors.white,
    minHeight: '45vh',
  },
  unsubscribeContainer: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
  },
  roboIcon: { display: 'flex', justifyContent: 'center', alignItems: 'center' },
  header: {
    marginTop: '1.25rem',
    fontFamily: 'Prelo-Light, sans-serif',
    color: tokens.colors.rsmGray.copy,
    fontWeight: '300',
    lineHeight: '2.5rem',
    fontSize: '2.25rem',
  },
  content: {
    paddingTop: '2.5rem',
    justifyItems: 'center',
    height: '50vh',
    alignContent: 'center',
  },
}

const Main = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.rsmBackground.main,
  paddingBottom: '2.5rem',
  flex: 1,
}))

const UnsubscribeProtectedRouteError = () => {
  const { t } = useTranslation()

  return (
    <ThemeProvider theme={normalTheme}>
      <Box sx={styles.unsubscribeContainer}>
        <Main>
          <Box sx={styles.toolbarContainer}>
            <Toolbar disableGutters sx={styles.toolbarRedesign}>
              <Box sx={styles.homeIcon}>
                <NewRsmLogo titleDescription="myRSM home" />
              </Box>
            </Toolbar>
          </Box>
          <Box sx={styles.content}>
            <Box sx={styles.roboIcon}>
              <RoboIcon />
            </Box>
            <Typography variant="h1" sx={styles.header}>
              {t('PageUnavailableHeader')}
            </Typography>
          </Box>
        </Main>
        <Footer />
      </Box>
    </ThemeProvider>
  )
}

export default UnsubscribeProtectedRouteError
